import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=295c5903&scoped=true"
import script from "./RoleManage.vue?vue&type=script&lang=js"
export * from "./RoleManage.vue?vue&type=script&lang=js"
import style0 from "./RoleManage.vue?vue&type=style&index=0&id=295c5903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295c5903",
  null
  
)

export default component.exports